export default __webpack_public_path__ + "static/information-3a533664986cd77ae3f16e2543b24756.webp";